import { Injectable } from "@angular/core";
import {
  MatLegacyDialog as MatDialog,
  MatLegacyDialogRef as MatDialogRef
} from "@angular/material/legacy-dialog";
import { CatalogEditComponent } from "../catalog-edit.component";
import { CatalogEditDialogData } from "./item-create-dialog.data";
import { CTManagerItemStock } from "projects/ct-manager/src/app/_core/classes/ct-manager-item-stock";

@Injectable()
export class ItemCreateDialogService {

  constructor(private dialog: MatDialog) {}

  /**
   * Apre CatalogEditComponent come dialog per la creazione di un nuovo Item.
   *
   * Il callback `onItemSaved` viene invocato ad ogni salvataggio riuscito
   * (la dialog rimane aperta) — utile per aggiornare la datatable in tempo reale.
   *
   * Alla chiusura tramite il bottone "Chiudi", la dialog restituisce
   * il CTManagerItemStock dell'ultimo articolo creato (o null se nessuno).
   *
   * @param onItemSaved - Callback invocato ad ogni salvataggio riuscito
   * @returns MatDialogRef tipizzato con CTManagerItemStock | null
   */
  open(
    onItemSaved: (stock: CTManagerItemStock) => void
  ): MatDialogRef<CatalogEditComponent, CTManagerItemStock | null> {

    const data: CatalogEditDialogData = CatalogEditDialogData
      .create()
      .setTypePathValue("item")
      .setOnItemSaved(onItemSaved);

    return this.dialog.open(CatalogEditComponent, {
      disableClose: true,   // chiusura solo tramite bottone "Chiudi"
      data,
      minWidth:  "80vw",
      maxHeight: "90vh"
    });

  }

}
